import React from "react";
import { withStyles } from "@material-ui/core";
import { get, filter, map, sortBy, includes, uniq, concat } from "lodash";

import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  menuItem: {
    fontSize: "1em",
    height: "48px",
    padding: "0px 24px 0px 18px",
  },
  itemText: {
    color: colors.black54,
  },
  checkboxRoot: {
    padding: 0,
    margin: "9px 9px 9px 0px",
  },
};

const MultiLevelSelectItem = withStyles(styles)((props) => {
  const {
    classes,
    item,
    values,
    level,
    onChange,
    selectItem,
    unselectItem,
    isChecked,
    isIndeterminate,
  } = props;

  const checked = isChecked(item);
  const indeterminate = isIndeterminate(item) && !checked;

  const [open, setOpen] = React.useState(checked || indeterminate);

  const handleChange = () => {
    let newValues;
    if (get(item, ["options"])) {
      if (checked) {
        newValues = unselectItem(item, values);
      } else {
        newValues = selectItem(item, values);
      }
    } else {
      newValues = includes(values, item.id)
        ? filter(values, (v) => v !== item.id)
        : concat(values, item.id);
    }
    onChange(uniq(newValues));
  };

  const expand = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  return (
    <>
      <MenuItem
        disableRipple
        value={item.id}
        classes={{ root: classes.menuItem }}
        style={{ paddingLeft: `${24 + 35 * level}px` }}
        onClick={handleChange}
      >
        {get(item, ["options"]) && (
          <span style={{ width: "20px" }} onClick={expand}>
            <img
              src={open ? images.arrowOpenBlack : images.arrowClosedBlack}
              alt="arrow"
              width={open ? "10px" : "8px"}
            />
          </span>
        )}
        <Checkbox
          color="primary"
          size="small"
          classes={{ root: classes.checkboxRoot }}
          checked={checked || indeterminate}
          indeterminate={indeterminate}
        />
        <Box component="span" className={classes.itemText}>
          {item.name}
        </Box>
      </MenuItem>
      {open &&
        map(
          sortBy(get(item, ["options"]), (opt) => opt.name),
          (opt, index) => (
            <MultiLevelSelectItem
              key={index}
              values={values}
              item={opt}
              level={level + 1}
              onChange={onChange}
              selectItem={selectItem}
              unselectItem={unselectItem}
              isChecked={isChecked}
              isIndeterminate={isIndeterminate}
            />
          )
        )}
    </>
  );
});

export default MultiLevelSelectItem;
